module.exports = __webpack_public_path__ + "static/media/gameAsPerformance1.2b978101.jpg";